import React from "react";
import {
  BodyWrapper,
  BrushContainer,
  CardContent,
  CardDouble,
  CardVideo,
  Container,
  DoubleVideoWrapper,
  MobileContainer,
  MobileWrapper,
  MultipleCardContent,
  MultipleVideoCard,
  MultipleVideoDescription,
  MultipleVideoTitle,
  MultipleVideoWrapper,
  MutltipleCardVideo,
  SingleVideoWrapper,
  Title,
  VideoDescription,
  VideoTitle,
} from "./Video.styled";
import YouTube from "react-youtube";
import { func } from "../../../../utils";
import CardSlider from "../../../../components/atoms/CardSlider";
import useWindowSize from "../../../../hooks/useWindowSize";
import Show from "../../FormRegistration/components/Show";

export interface VideoItemProps {
  id: number;
  title: string;
  subtitle: string;
  slug: string;
  category: string;
  key_visual: string;
  key_visual_mobile: string;
  video_url: string;
  created_at: string;
  order: number;
}

export interface VideoProps {
  data: VideoItemProps[];
}

const Video: React.FC<VideoProps> = ({ data }) => {
  const playerRef = React.useRef<any>(null);

  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 768;

  const getVideoId = (url) => {
    if (!url) return "";
    return url.split("/").pop() || "";
  };

  const handleVideoClick = (videoId: string) => {
    if (videoId) {
      // Stop video if player exists
      if (playerRef.current) {
        try {
          playerRef.current.stopVideo();
          // Alternative: playerRef.current.stopVideo();
        } catch (error) {
          console.log("Error stopping video:", error);
        }
      }

      // Redirect to YouTube
      window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
    }
  };

  // Store YouTube player instance when it's ready
  const onReady = (event: any) => {
    playerRef.current = event.target;
  };

  // YouTube player options
  const opts = {
    playerVars: {
      controls: 0,
      rel: 0,
      modestbranding: 1,
      iv_load_policy: 3,
      playsinline: 1,
    },
  };

  const renderContent = () => {
    const videoLength = data?.length || 0;

    if (videoLength <= 0) return null;

    if (videoLength === 1) {
      const item = data?.[0];
      const videoId = getVideoId(item?.video_url);

      return (
        <SingleVideoWrapper>
          <CardVideo style={{ cursor: "pointer" }} count={1}>
            <YouTube
              loading="lazy"
              videoId={videoId}
              className="media-player"
              ref={playerRef}
              onReady={onReady}
              // @ts-ignore
              opts={opts}
              onPlay={() => {
                handleVideoClick(videoId);
              }}
            />
          </CardVideo>
          <CardContent count={1}>
            <VideoTitle>{item?.title}</VideoTitle>
            <VideoDescription>{item?.subtitle}</VideoDescription>
          </CardContent>
        </SingleVideoWrapper>
      );
    }

    if (videoLength === 2) {
      return (
        <DoubleVideoWrapper>
          {data?.map((item, idx) => {
            const videoId = getVideoId(item?.video_url);

            return (
              <CardDouble key={idx}>
                <CardVideo style={{ cursor: "pointer" }} count={2}>
                  <YouTube
                    loading="lazy"
                    videoId={videoId}
                    className="media-player"
                    ref={playerRef}
                    onReady={onReady}
                    // @ts-ignore
                    opts={opts}
                    onPlay={() => {
                      handleVideoClick(videoId);
                    }}
                  />
                </CardVideo>
                <CardContent count={2}>
                  <VideoTitle>{item?.title}</VideoTitle>
                  <VideoDescription>{item?.subtitle}</VideoDescription>
                </CardContent>
              </CardDouble>
            );
          })}
        </DoubleVideoWrapper>
      );
    }

    return (
      <CardSlider totalData={data?.length}>
        {data?.map((item, idx) => {
          const videoId = getVideoId(item?.video_url);

          return (
            <MultipleVideoCard key={idx}>
              <MutltipleCardVideo>
                <YouTube
                  loading="lazy"
                  videoId={videoId}
                  className="media-player"
                  ref={playerRef}
                  onReady={onReady}
                  // @ts-ignore
                  opts={opts}
                  onPlay={() => {
                    handleVideoClick(videoId);
                  }}
                />
              </MutltipleCardVideo>
              <MultipleCardContent>
                <MultipleVideoTitle>{item?.title}</MultipleVideoTitle>
                <MultipleVideoDescription>{item?.subtitle}</MultipleVideoDescription>
              </MultipleCardContent>
            </MultipleVideoCard>
          );
        })}
      </CardSlider>
    );
  };

  return (
    <Container>
      <BrushContainer>
        <img src={func.getStaticImg("/illustration/brush-video.png")} />
      </BrushContainer>
      {!isMobileView ? (
        <React.Fragment>
          <Show when={data?.length <= 2}>
            <BodyWrapper>
              <Title>Video</Title>
              {renderContent()}
            </BodyWrapper>
          </Show>
          <Show when={data?.length > 2}>
            <MultipleVideoWrapper>
              <Title className="section-title">Video</Title>
              {renderContent()}
            </MultipleVideoWrapper>
          </Show>
        </React.Fragment>
      ) : (
        <MobileContainer>
          <Title>Video</Title>
          <MobileWrapper>
            {data?.map((item, idx) => {
              const videoId = getVideoId(item?.video_url);

              return (
                <MultipleVideoCard key={idx}>
                  <MutltipleCardVideo>
                    <YouTube
                      loading="lazy"
                      videoId={videoId}
                      className="media-player"
                      ref={playerRef}
                      onReady={onReady}
                      // @ts-ignore
                      opts={opts}
                      onPlay={() => {
                        handleVideoClick(videoId);
                      }}
                    />
                  </MutltipleCardVideo>
                  <MultipleCardContent>
                    <MultipleVideoTitle>{item?.title}</MultipleVideoTitle>
                    <MultipleVideoDescription>{item?.subtitle}</MultipleVideoDescription>
                  </MultipleCardContent>
                </MultipleVideoCard>
              );
            })}
          </MobileWrapper>
        </MobileContainer>
      )}
    </Container>
  );
};

export default Video;
